// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TabletFilledSvg from "@ant-design/icons-svg/es/asn/TabletFilled";
import AntdIcon from '../components/AntdIcon';

var TabletFilled = function TabletFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TabletFilledSvg
  }));
};

TabletFilled.displayName = 'TabletFilled';
export default React.forwardRef(TabletFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TabletFilled.js
// module id = 1905
// module chunks = 0